import script from "./NewsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDetail.vue?vue&type=script&setup=true&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=125e693c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125e693c"]])

export default __exports__